function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
import get from 'lodash/get';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import includes from 'lodash/includes';
import Papa from 'papaparse';
import { mapState, mapGetters } from 'vuex';
import saveAs from 'file-saver';
export default {
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    completed: function completed(s) {
      return s.api.executionState === 'completed';
    },
    groups: function groups(s) {
      return s.api.query.groups;
    },
    frequencyValuesSelected: function frequencyValuesSelected(s) {
      return s.frequency_groups.frequencyValues;
    },
    frequencyGroupSelected: function frequencyGroupSelected(s) {
      return s.frequency_groups.frequencyGroups;
    },
    result: function result(s) {
      return s.api.result;
    }
  })), mapGetters({
    page: 'pagination/currentPage',
    pageSize: 'pagination/currentPageSize',
    resultType: 'api/resultType'
  })), {}, {
    resultRows: function resultRows() {
      var _this = this;

      return map(this.result.matching_expressions, function (row) {
        var totalName = _this.$t('result.matching_expressions.total');

        var normalized = _this.normalizeFrequency(row.elements, _this.result.reference.elements_reference);

        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, reduce(row.groups.left, function (r, e, i) {
          return _objectSpread(_objectSpread({}, r), _this.elementGroups(e, i));
        }, {})), reduce(row.groups.right, function (r, e, i) {
          return _objectSpread(_objectSpread({}, r), _this.elementGroups(e, i));
        }, {})), _this.frequencyValues("".concat(totalName, ": ").concat(_this.$t('result.matching_expressions.cell_frequency.elements')), row.elements, "".concat(totalName, ": ").concat(_this.$t('result.matching_expressions.cell_frequency.normalized')), normalized, "".concat(totalName, ": ").concat(_this.$t('result.matching_expressions.cell_frequency.documents')), row.documents)), _this.frequencyGroups(row.frequencies));
      });
    }
  }),
  methods: {
    elementGroups: function elementGroups(element, index) {
      var _this2 = this;

      return reduce(this.groups, function (r, g) {
        var name = "".concat(_this2.$t("groups.selector.options.".concat(g)), " ").concat(index + 1);
        var tagName = g === 'tag' ? {
          '': _this2.$tTag(element[g])
        } : {};
        return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, name, element[g]), tagName);
      }, {});
    },
    frequencyValues: function frequencyValues(frequencyName, frequency, normalizedName, normalized, documentsName, documents) {
      var frequencyValues = {};

      if (includes(this.frequencyValuesSelected, 'frequency')) {
        frequencyValues[frequencyName] = frequency;
      }

      if (includes(this.frequencyValuesSelected, 'normalized')) {
        frequencyValues[normalizedName] = normalized;
      }

      frequencyValues[documentsName] = documents;
      return frequencyValues;
    },
    frequencyGroups: function frequencyGroups(frequency) {
      var _this3 = this;

      var elementsFrequencyName = this.$t('result.matching_expressions.cell_frequency.elements');
      var normalizedFrequencyName = this.$t('result.matching_expressions.cell_frequency.normalized');
      var documentsFrequencyName = this.$t('result.matching_expressions.cell_frequency.documents');
      return reduce(this.frequencyGroupSelected, function (r, vs, g) {
        var groupName = _this3.$tOr('result.matching_expressions.groups', "".concat(g, ".name"), g);

        var groupColumns = reduce(vs, function (gr, v) {
          var groupValueName = _this3.$tOr('result.matching_expressions.groups', "".concat(g, ".values.").concat(v), v);

          var elements = get(frequency, [g, v, 'elements'], 0);
          var elementsReference = get(_this3.result.full_reference, [g, v, 'elements_reference'], 0);
          var documents = get(frequency, [g, v, 'documents'], 0);

          var normalized = _this3.normalizeFrequency(elements, elementsReference);

          return _objectSpread(_objectSpread({}, gr), _this3.frequencyValues("".concat(groupName, ": ").concat(groupValueName, ": ").concat(elementsFrequencyName), elements, "".concat(groupName, ": ").concat(groupValueName, ": ").concat(normalizedFrequencyName), normalized, "".concat(groupName, ": ").concat(groupValueName, ": ").concat(documentsFrequencyName), documents));
        }, {});
        return _objectSpread(_objectSpread({}, r), groupColumns);
      }, {});
    },
    normalizeFrequency: function normalizeFrequency(elements, reference) {
      // First case can only happen when there is one group value that only matches documents with no elements
      return elements === 0 && reference === 0 ? 0 : Math.round(elements * 1000000 / reference);
    },
    downloadCsv: function downloadCsv() {
      var delimiter = this.$ncsConfig.download.kwic.delimiter;
      var resultCsv = Papa.unparse(this.resultRows, {
        delimiter: delimiter,
        newline: "\n"
      });
      var blob = new Blob([resultCsv], {
        type: "text/csv;charset=utf-8"
      });
      saveAs(blob, this.$ncsConfig.download.kwic.filename);
    }
  }
};